import { render } from "./SubmissionModal.vue?vue&type=template&id=6701d32e&scoped=true"
import script from "./SubmissionModal.vue?vue&type=script&lang=js"
export * from "./SubmissionModal.vue?vue&type=script&lang=js"

import "./SubmissionModal.vue?vue&type=style&index=0&id=6701d32e&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6701d32e"]])

export default __exports__